import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import React from 'react'
import './style.scss'

interface KeyCabinetBadgeProps {
  id: string
  fromWarehouse?: boolean
  purpose?: warehouse.WarehouseActionKeyCabinetGrantPurpose
}

const KeyCabinetBadge: React.FC<KeyCabinetBadgeProps> = ({ id, fromWarehouse, purpose }) => {
  const { t } = useTranslation('keyCabinet')
  const { push } = useHistory()
  return (
    <div className='keyCabinet__badge__wrapper'>
      <div className='keyCabinet__badge'>
        <div className='keyCabinet__badge__content'>
          <i className='icon icon--key' />
          <span>{t(purpose === 'return' ? 'returnKey' : 'collectKey')}</span>
        </div>
        <ArrowBtn
          showArrow={false}
          className='--black'
          text={t('openKeyCabinet')}
          action={() => {
            push(`/warehouses/${id}/keycabinet${fromWarehouse ? '?from=mag' : ''}`)
          }}
        />
      </div>
    </div>
  )
}

export default KeyCabinetBadge